import { NetworkService } from '../../../../services/networkService';

export const getLeadCallRecording = async (recordingUUID) => {
  const response = await NetworkService.get(`/api/lms/recordings/call?id=${recordingUUID}`, {}, {}, false, () => true, {
    responseType: 'blob',
  });
  if (response?.error) {
    return response;
  } else if (response?.data) {
    const url = URL.createObjectURL(response.data);
    return url;
  }
};
